import { render, staticRenderFns } from "./volunteerLogin.vue?vue&type=template&id=d397a676&scoped=true&"
import script from "./volunteerLogin.vue?vue&type=script&lang=js&"
export * from "./volunteerLogin.vue?vue&type=script&lang=js&"
import style0 from "./volunteerLogin.vue?vue&type=style&index=0&id=d397a676&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d397a676",
  null
  
)

export default component.exports